import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

import { FaUpload } from 'react-icons/fa';

const FileInput = ({ setfiles }) => {
	const onDrop = useCallback(
		(acceptedFiles) => {
			console.log(acceptedFiles);
			setfiles(acceptedFiles.map((file) => Object.assign(file, { preview: URL.createObjectURL(file) })));
		},
		[ setfiles ]
	);
	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		onDrop,
		multiple: false,
		accept: 'image/*, application/msword, .doc, .docx, application/pdf ',
	});

	return (
		<div {...getRootProps()} className={'form-control dropzone ' + (isDragActive && 'dropzone--isActive')}>
			<input {...getInputProps()} />

			<div>
				<FaUpload />Upload File
			</div>
		</div>
	);
};

export default FileInput;
